import React from 'react';
import { InputAdornment } from '@material-ui/core';
import CardIcon from './CardIcon';
const StartAdornment = (props) => (React.createElement(InputAdornment, Object.assign({ position: "start" }, props),
    React.createElement(CardIcon, null)));
export default StartAdornment;
